module.exports = __webpack_public_path__ + "static/mobile_logo-73f788b829769576d76bcf31f2be95c3.png";